export function getAppVersion(ua = navigator.userAgent) {
  return isWebView(ua) ? ua.replace(/GNaviDaicho\/(?:P\.)?([^\s]+).*/, '$1') : null
}

export function isWebView(ua = navigator.userAgent) {
  return ua.includes('GNaviDaicho/')
}
